import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_design_template');

interface FileUploadPreviewProps {
  file: File;
  onRemove: () => void;
}

const FileUploadPreview: React.FC<FileUploadPreviewProps> = ({ file, onRemove }) => {
  const location = useLocation();
  const [previewUrl, setPreviewUrl] = useState<string>('');

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  const isImage = file.type.startsWith('image/');
  const isPdf = file.type === 'application/pdf';
  const fileSize = (file.size / (1024 * 1024)).toFixed(2);

  return (
    <div className="mt-3 border rounded bg-light p-3">
      <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
        <div className="text-truncate">
          <i className="ri-file-line me-1"></i>
          <span className="fw-semibold">{file.name}</span>
          <span className="text-muted ms-2">({fileSize} {st('mb_text')}</span>
        </div>
        {PageActionPermission.canDisplay(location.pathname, "button-remove-selected-file") && (
          <Button
            color="danger"
            outline
            size="sm"
            type="button"
            data-action-code="button-remove-selected-file"
            data-action-name="Bỏ chọn file đã tải lên"
            onClick={onRemove}
          >
            <i className="ri-delete-bin-line me-1"></i>
            {st('xoa_button')}
          </Button>
        )}
      </div>

      {previewUrl && isImage && (
        <div className="text-center bg-white border rounded p-2">
          <img
            src={previewUrl}
            alt={file.name}
            style={{ maxWidth: '100%', maxHeight: '320px', objectFit: 'contain' }}
          />
        </div>
      )}

      {previewUrl && isPdf && (
        <div className="bg-white border rounded" style={{ height: '360px' }}>
          <iframe
            src={previewUrl}
            title={file.name}
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </div>
      )}
    </div>
  );
};

export default FileUploadPreview;
